"use strict";

import angular from "angular";

import "./themes/user-profile-sidenav-dark.component.scss";
import "./themes/user-profile-sidenav.component.scss";
import template from "./user-profile-sidenav.component.html";

import _ from "lodash";

import { Events } from "../../../presentation/services/Events/Events";

import { User } from "../../../gateway/User/User";
import { EmailSESService } from "../../../presentation/services/EmailSES/EmailSES";

import tippy from "tippy.js";
import { AccountingEntity } from "../../../entity/AccountingEntity";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import { RequestAnalysisPlus } from "../../../presentation/services/RequestActiveAnalysisPlus/RequestActiveAnalysisPlus";
import { RequestChangePlan } from "../../../presentation/services/RequestChangePlan/RequestChangePlan";
import {
    GetUserApiAppSecretUsecase,
    SaveManyUserUsecase,
    UpdateUserBrowserStorageUsecase
} from "../../../usecases";
import { nucontersUsers } from "../../../utils/users-roles/users-roles";

import changeTempPasswordTemplate from "../../dialogs/change-temp-password/change-temp-password.html";
import dialogChangePasswordTemplate from "../../dialogs/dialog-change-password/dialog-change-password.html";
import userProfileAvatarDialogTemplate from "../../dialogs/user-profile-avatar/user-profile-avatar-dialog.html";

export class UserProfileSidenavComponent {
    accountingEntity = {};
    tokenIntegration = "...";
    tokenIntegrationView = "";
    tippyIntegration = {};
    isCopiedTokenIntegration = false;
    constructor(
        $mdDialog,
        $state,
        $rootScope,
        $element,
        UserProfileSidenavService,
        DSNDialogService,
        ThemesService,
        $scope,
        PopupFeatureService,
        toast,
        AccountingPlanService,
        JWTService
    ) {
        this.$mdDialog = $mdDialog;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$element = $element;
        this.UserProfileSidenavService = UserProfileSidenavService;
        this.DSNDialogService = DSNDialogService;
        this.ThemesService = ThemesService;
        this.$scope = $scope;
        this.PopupFeatureService = PopupFeatureService;
        this.toast = toast;
        this.AccountingPlanService = AccountingPlanService;
        this.JWTService = JWTService;
        this.Events = new Events();
        this.User = new User();

        this.RequestAnalysisPlus = new RequestAnalysisPlus({
            DSNDialogService: this.DSNDialogService,
            toast: this.toast,
            mdDialog: this.$mdDialog
        });
        this.darkMode = false;

        this.version = window._version;
        this.maxImageSize = "5MB";
        this.isBusinnes = false;
        this.isContractButton = false;
        this.isInternalUser = false;
    }

    $onInit() {
        this.UserProfileSidenavService.setElementContext(this.$element);
        this.accountingEntity = new AccountingEntity(
            this.UserProfileSidenavService.accounting
        );

        this.setTriggerTippy();
        this.setTokenIntegration();
    }

    setTriggerTippy() {
        setTimeout(() => {
            const [ty] = tippy("#UserProfileSideNavComponentTokenIntegration", {
                duration: 3,
                content: "Chave de integração copiada com sucesso!",
                trigger: "click",
                allowHTML: false,
                placement: "bottom",
                animation: "fade",
                hideOnClick: true
            });

            this.tippyIntegration = ty;
        }, 500);
    }

    async setTokenIntegration() {
        const getUserApiAppSecretUsecase = new GetUserApiAppSecretUsecase();
        const appSecret = await getUserApiAppSecretUsecase.execute({
            accountingId: this.accountingEntity.props._id
        });
        this.tokenIntegration = appSecret;
        this.tokenIntegrationView = angular.copy(
            `${this.tokenIntegration.slice(0, 25)}...`
        );
        this.$scope.$applyAsync();
    }

    onClipBoard() {
        this.isCopiedTokenIntegration = true;
        navigator.clipboard.writeText(this.tokenIntegration);
        setTimeout(() => {
            this.isCopiedTokenIntegration = false;
            this.tippyIntegration.hide();
        }, 550);
    }

    $onChanges(changes) {
        if (changes.user && _.get(changes, "user.currentValue._id")) {
            this.onViewInit();
        }
    }

    onRequestAnalysisPlus() {
        this.RequestAnalysisPlus.onOpenDialogRequestAnalysisPlusPlan(
            this.accountingEntity
        );
    }

    $onDestroy() {}

    onGetPercentage(currentValue, totalValue) {
        return (currentValue / totalValue) * 100;
    }

    getAccountingSuperLogicaId() {
        return this.UserProfileSidenavService.accounting?.superLogica?._id;
    }

    getAccountingHubspotId() {
        return this.UserProfileSidenavService.accounting?.hubspot?._id;
    }

    getUserRoleLabel() {
        const role = this.UserProfileSidenavService.user?.roles?.[0];
        return this.User._transformRole(role) || role;
    }

    onViewInit() {
        if (!this.user) return;
        this.openChangePasswordDialog();
        this.setAccountingActiveUser();

        this.isContractButton = this.User.checkPermission({
            roles: ["Contabilidade"],
            granted: _.get(this.user, "roles")
        });
        if (this.user.roles.includes("Empresa")) this.isBusinnes = true;
        this.isInternalUser = this.User.checkPermission({
            roles: nucontersUsers,
            granted: _.get(this.user, "roles")
        });
        const currentTheme = this.ThemesService.setTheme(
            _.get(this.user, "profile.theme") || "light"
        );

        this.darkMode = currentTheme === "dark" ? true : false;
    }

    openChangePasswordDialog() {
        if (!this.UserProfileSidenavService?.accounting?._id) return;
        if (this.user?.profile?.featureFlag?.tempPassword !== 0) return;
        this.DSNDialogService.custom({
            controller: "DialogChangeTempPassword as $ctrl",
            clickOutsideToClose: false,
            locals: {
                templateHtml: changeTempPasswordTemplate,
                width: "770px",
                title: "Alterar Senha"
            },
            after: {}
        });
        this.PopupFeatureService.updateFlag(
            "tempPassword",
            this.UserProfileSidenavService?.accounting?._id
        );
    }

    setAccountingActiveUser() {
        const _isPermission = (granted) => {
            return this.User.checkPermission({
                roles: _.get(this.user, "roles"),
                granted: granted
            });
        };

        this.isAccountingActiveUser = _isPermission(["Contabilidade"]);
    }

    close() {
        this.UserProfileSidenavService.close();
    }

    toggleDarkMode(dark) {
        const theme = dark ? "dark" : "light";
        const currentTheme = this.ThemesService.setTheme(theme);
        const saveManyUserUsecase = new SaveManyUserUsecase();
        const userId = new UserDataAdapter().user()._id;
        saveManyUserUsecase.execute({
            accountingId: this.UserProfileSidenavService?.accounting?._id,
            users: [{ _id: userId, applicationTheme: currentTheme }]
        });
        const updateUserBrowserStorageUsecase = new UpdateUserBrowserStorageUsecase();
        updateUserBrowserStorageUsecase.execute({
            theme: currentTheme
        });
        this.Events.send(`Tema.${theme}`);
    }

    onRequestCS() {
        this.Events.send("Plano.solicitar.upgrade");

        this.$rootScope.$broadcast(
            "SET_NANDA_NOTIFICATION",
            "CS_CONTATO_UPGRADE"
        );

        setTimeout(() => {
            this.$rootScope.$broadcast("SET_NANDA_NOTIFICATION", "CLEAR");
        }, 5000);
    }

    /**
     * @public
     * Abre dialog de troca de senha
     * @param {Object} $event
     */
    openDialogChangePassword() {
        this.close();
        this.DSNDialogService.custom({
            controller: "DialogChangePasswordCtrl as $ctrl",
            clickOutsideToClose: false,
            locals: {
                templateHtml: dialogChangePasswordTemplate,
                width: "770px",
                title: "Alterar Senha"
            },
            after: {}
        });
    }

    logout() {
        this.JWTService.signout();
    }

    handleFiles(imageFile) {
        if (imageFile && imageFile[0]) {
            let reader = new FileReader();

            reader.onload = () => {
                this.onChangeAvatar(reader.result);
            };

            reader.readAsDataURL(imageFile[0]);
        } else {
        }
    }

    async updateAvatar(imageUrl) {
        this.user.profile.picture = imageUrl;
        const saveManyUserUsecase = new SaveManyUserUsecase();
        const userId = new UserDataAdapter().user()._id;
        saveManyUserUsecase.execute({
            accountingId: this.UserProfileSidenavService?.accounting?._id,
            users: [{ _id: userId, picture: imageUrl }]
        });
        const updateUserBrowserStorageUsecase = new UpdateUserBrowserStorageUsecase();
        updateUserBrowserStorageUsecase.execute({
            picture: imageUrl
        });
    }

    onChangeAvatar(imageData) {
        this.DSNDialogService.custom({
            controller: "UserProfileAvatarDialogCtrl as $ctrl",
            clickOutsideToClose: false,
            escapeToClose: false,
            locals: {
                templateHtml: userProfileAvatarDialogTemplate,
                width: "478px",
                title: "Atualizar foto de perfil",
                imageData,
                path: "gestao-de-contas",
                currentImage: this.user?.profile?.picture
            },
            after: {
                hide: (imageUrl) => {
                    this.updateAvatar(imageUrl);
                }
            }
        });
    }

    sendEmail() {
        if (publicSettings.environment != "production") return;

        const templateString = this.templateEmail({
            plan: this.UserProfileSidenavService.accounting.contract,
            hubspotId: _.get(
                this.UserProfileSidenavService.accounting,
                "hubspot._id"
            ),
            accountingCode: _.get(
                this.UserProfileSidenavService.accounting,
                "superLogica._id"
            ),
            userName: this.user.profile.nickname || this.user.profile.name,
            email: this.user.username
        });

        const senderEmail = new EmailSESService();

        const subject = `Quero mudar de plano: ${this.UserProfileSidenavService.accounting.name}`;

        senderEmail.sendBulk({
            subject: subject,
            to: [
                { name: "Nucont Hackers", email: "nuconthackers@gmail.com" },
                { name: "Hadna Esteves", email: "hadna.esteves@nucont.com" },
                {
                    name: "Matheus Queiroga",
                    email: "matheus.queiroga@nucont.com"
                },
                {
                    name: "Fernando Pinheiro",
                    email: "fernando.pinheiro@nucont.com"
                },
                { name: "Thaina Souza", email: "thaina.souza@nucont.com" },
                { name: "Vinicius", email: "vinicius@nucont.com" }
            ],
            from: {
                name: "Nucont PRO",
                email: "nanda@nucont.com"
            },
            bodyOptions: {
                reference: "ComunicacaoInterna",
                defaultParams: {
                    subject: subject,
                    templateString
                }
            }
        });
    }

    onRequestChangePlan($event) {
        const requestChangePlan = new RequestChangePlan({
            DesnuDialogService: this.DSNDialogService,
            accountingEntity: this.accountingEntity
        });
        requestChangePlan.execute($event);
    }

    templateEmail({
        plan,
        hubspotId,
        accountingCode,
        feature,
        userName,
        email
    }) {
        return `

        <table
        style="
            font-family: Open Sans, sans-serif;
            width: 100%;
            color: #2e5573;
            font-size: 16px;
        "
    >
        <tbody>
            <tr>
                <td valign="top">
                    <table
                        cellpadding="0"
                        cellspacing="0"
                        border="0"
                        style="
                            height: 4px;
                            width: 100%;
                            background-color: #00cbd2;
                            margin-bottom: 24px;
                        "
                    >
                        <tbody>
                            <tr></tr>
                        </tbody>
                    </table>
                    <h1
                        style="
                            text-align: center;
                            font-size: 24px;
    
                            margin: 0;
    
                            font-family: Open Sans, sans-serif;
                        "
                    >
                        Solicitação de mudança do plano
                    </h1>
                    <table
                        border="0"
                        cellpadding="0"
                        cellspacing="0"
                        width="100%"
                        style="
                            font-size: 0;
                            height: 30px;
                            width: 100%;
                            min-width: 100%;
                            line-height: 0;
                        "
                    >
                        <tbody>
                            <tr>
                                <td height="30">
                                    <span
                                        style="
                                            color: transparent;
                                            background: none;
                                            text-overflow: ellipsis;
                                            opacity: 0;
                                            width: 100%;
                                            min-width: 100%;
                                            height: 1;
                                            padding: 0;
                                            font-size: 0;
                                        "
                                    >
                                        &nbsp;</span
                                    >
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
            <tr>
                <td>
                    <p><strong>Plano atual:</strong> ${plan}</p>
                    <p>
                        <strong>Código no Hubspot:</strong> ${hubspotId}
                    </p>
                    <p><strong>Código da Nucont:</strong> ${accountingCode}</p>
                    <p>
                        <strong>Usuário:</strong>
                        ${userName} (${email})
                    </p>
                </td>
            </tr>
        </tbody>
    </table>
    
        `;
    }
}

UserProfileSidenavComponent.$inject = [
    "$mdDialog",
    "$state",
    "$rootScope",
    "$element",
    "UserProfileSidenavService",
    "DSNDialogService",
    "ThemesService",
    "$scope",
    "PopupFeatureService",
    "toast",
    "AccountingPlanService",
    "JWTService"
];

const name = "userProfileSidenavComponent";
const def = {
    bindings: {
        user: "<",
        accountingId: "<"
    },
    controller: UserProfileSidenavComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
